<template>
    <div style="max-width: 400px">
        <v-row>
            <v-col v-if="!formField.editable">
                <!-- Undefined and true are both interpreted as true -->
                <span v-if="formField.disabledMessage">
                    <v-icon v-bind="props" color="orange">$alert</v-icon>
                    <span class="text-caption">{{ formField.disabledMessage }}</span>
                </span>
                <v-text-field
                    v-if="formField.disabledMessage"
                    disabled
                    :label="formField.label"
                    :model-value="getDisplayValue()"
                    ref="field"
                />
                <v-text-field
                    v-else
                    disabled
                    :label="formField.label"
                    :model-value="getDisplayValue()"
                    ref="field"
                />
            </v-col>
            <v-col
                v-else-if="
                    formField.attribute.type === 'string' &&
                    formField.attribute.widget_type === 'dropdown'
                "
            >
                <v-autocomplete
                    :items="formField.attribute.options"
                    v-model="value"
                    :label="formField.label"
                    :rules="formField.validationRules"
                    ref="field"
                />
            </v-col>
            <v-col
                v-else-if="
                    formField.attribute.type === 'string' || formField.attribute.type === 'number'
                "
            >
                <v-text-field
                    :label="formField.label"
                    v-model="value"
                    :validate-on="false ? 'blur' : undefined"
                    :rules="formField.validationRules"
                    :type="formField.attribute.type === 'number' ? 'number' : 'text'"
                    ref="field"
                />
            </v-col>
            <v-col v-else-if="formField.attribute.type === 'entry_relation'">
                <v-autocomplete
                    clearable
                    :items="getEntryRelationOptions()"
                    item-title="displayName"
                    :label="formField.label"
                    v-model="formField.value"
                    :rules="formField.validationRules"
                    ref="field"
                />
            </v-col>
            <v-col v-else-if="formField.attribute.type === 'global_relation'">
                <v-autocomplete
                    v-if="attribute.allow_multiple_values"
                    clearable
                    multiple
                    :items="getGlobalRelationOptions()"
                    item-title="displayName"
                    item-value="value"
                    :label="formField.label"
                    v-model="value"
                    :rules="formField.validationRules"
                    ref="field"
                />
                <v-autocomplete
                    v-else
                    clearable
                    :items="getGlobalRelationOptions()"
                    item-title="displayName"
                    item-value="value"
                    :label="formField.label"
                    v-model="value"
                    :rules="formField.validationRules"
                    ref="field"
                />
            </v-col>
            <v-col v-else-if="formField.attribute.type === 'string_array'">
                <v-textarea
                    :label="formField.label"
                    v-model="formField.value"
                    rows="1"
                    :rules="formField.validationRules"
                    ref="field"
                />
            </v-col>
            <v-col v-else-if="formField.attribute.type === 'date'">
                <v-text-field
                    type="date"
                    v-model="value"
                    :label="formField.label"
                    prepend-icon="$calendar"
                    clearable
                    :rules="formField.validationRules"
                    ref="field"
                />
            </v-col>
            <v-col v-else-if="formField.attribute.type === 'datetime'">
                <v-text-field
                    type="datetime-local"
                    v-model="formField.value"
                    :label="formField.label"
                    :rules="formField.validationRules"
                    ref="field"
                />
            </v-col>
        </v-row>
    </div>
</template>
<script>
import {
    getEntryRelationOptionsForAttribute,
    getGlobalRelationOptionsForAttribute,
} from "@/lib/thingUtils.ts";
import { getMeasurementDisplayValue } from "@/lib/measurementsUtils.js";

import { defineComponent } from "vue";

export default defineComponent({
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        thingSchema: {
            type: Object,
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
        protocol: {
            type: Object,
            required: true,
        },
    },

    watch: {
        modelValue: {
            handler() {
                this.formField = this.modelValue;
                this.attribute = this.modelValue.attribute;
            },
            immediate: true,
        },
    },

    data() {
        return {
            attribute: null,
            formField: null,
        };
    },

    computed: {
        value: {
            get() {
                return this.modelValue.value;
            },
            set(value) {
                this.$emit("update:modelValue", { ...this.modelValue, value: value });
            },
        },
    },

    methods: {
        getEntryRelationOptions() {
            return getEntryRelationOptionsForAttribute(this.attribute, this.experiment);
        },
        getGlobalRelationOptions() {
            return getGlobalRelationOptionsForAttribute(this.attribute, this.protocol);
        },
        getDisplayValue() {
            const value = this.formField.value;
            return getMeasurementDisplayValue(
                value,
                this.attribute.name,
                this.thingSchema,
                this.experiment,
                this.protocol
            );
        },
    },

    mounted() {
        this.attribute = this.formField.attribute;
        // By default, Vue won't validate the initial state of the form field. This forces
        // validation. Their assumption is anything that initializes a form field should be valid, but that's
        // absolutely not true in reality.
        const input = this.$refs.field;
        if (input) {
            input.validate(true);
        }
    },
});
</script>
